import React from 'react';
// template components
import Col from '@nmx/template/dist/componentLibrary/foundations/Grid/Col';
import Link from '@nmx/template/dist/componentLibrary/components/Link';
import Picture from '@nmx/template/dist/componentLibrary/components/Picture';
import Row from '@nmx/template/dist/componentLibrary/foundations/Grid/Row';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
// icons
import CaratRight from '@nmx/template/dist/componentLibrary/foundations/Icon/icons/utility/CaratRight';
// images
import AnneAckerleyWebp from './images/anne-ackerley.webp';
import AartiShahWebp from './images/aarti-shah.webp';
import AndrewHarmeningWebp from './images/andrew-harmening.webp';
import AndrewNunemakerWebp from './images/andrew-nunemaker.webp';
import AnneParadisWebp from './images/anne-paradis.webp';
import DavidHollanderWebp from './images/david-hollander.webp';
import JamieMontemayorWebp from './images/jamie-montemayor.webp';
import JuanZarateWebp from './images/juan-zarate.webp';
import NicholasBrathwaiteWebp from './images/nicholas-brathwaite.webp';
import RalphWeberWebp from './images/ralph-weber.webp';
import RandolphMelvilleWebp from './images/randolph-melville.webp';
import RussellHardinWebp from './images/russell-hardin.webp';
import SandraRogersWebp from './images/sandra-rogers.webp';
import TimGerendWebp from './images/ceo-tim-gerend.webp';
import TimothyMurphyWebp from './images/timothy-murphy.webp';
// styles
import {
  ColStyled,
  DivStyledPictureContainer,
  DivStyledTrusteesGroupContainer,
  RowStyled,
  SectionContainerStyled,
  TypographyStyled,
} from './styles';

export const TRUSTEES = {
  rows: [
    [
      {
        image: AnneAckerleyWebp,
        name: 'Anne F. Ackerley',
        nameString: 'anne-ackerley',
        title: 'Senior Advisor, BlackRock',
        bioLink: '/assets/pdf/leaders/ackerley.pdf',
      },
      {
        image: NicholasBrathwaiteWebp,
        name: 'Nicholas E. Brathwaite',
        nameString: 'nicholas-brathwaite',
        title: 'Founding Managing Partner Celesta Capital',
        bioLink: '/assets/pdf/leaders/brathwaite.pdf',
      },
      {
        image: TimGerendWebp,
        name: 'Timothy J. Gerend',
        nameString: 'tim-gerend',
        title: 'Chairman, President, and Chief Executive Officer, Northwestern Mutual',
        bioLink: '/assets/pdf/leaders/gerend-tim-0225.pdf',
      },
    ],
    [
      {
        image: RussellHardinWebp,
        name: 'P. Russell Hardin',
        nameString: 'russell-hardin',
        title: 'President Robert W. Woodruff Foundation',
        bioLink: '/assets/pdf/leaders/hardin.pdf',
      },
      {
        image: AndrewHarmeningWebp,
        name: 'Andrew J. Harmening',
        nameString: 'andrew-harmening',
        title: 'Chief Executive Officer Associated Bank',
        bioLink: '/assets/pdf/leaders/harmening.pdf',
      },
      {
        image: DavidHollanderWebp,
        name: 'David P. Hollander',
        nameString: 'david-hollander',
        title: (<>Retired Principal, Global Insurance Sector Leader, Ernst &#38; Young, LLP</>),
        bioLink: '/assets/pdf/leaders/hollander.pdf',
      },
    ],
    [
      {
        image: RandolphMelvilleWebp,
        name: 'Randolph W. Melville',
        nameString: 'randolph-melville',
        title: (<>Retired Senior Vice President Frito&#45;Lay, North America</>),
        bioLink: '/assets/pdf/leaders/melville.pdf',
      },
      {
        image: JamieMontemayorWebp,
        name: 'Jaime Montemayor',
        nameString: 'jaime-montemayor',
        title: 'Chief Digital and Technology Officer, General Mills',
        bioLink: '/assets/pdf/leaders/montemayor.pdf',
      },
      {
        image: TimothyMurphyWebp,
        name: 'Timothy H. Murphy',
        nameString: 'timothy-murphy',
        title: 'Chief Administrative Officer Mastercard',
        bioLink: '/assets/pdf/leaders/murphy.pdf',
      },
    ],
    [
      {
        image: AndrewNunemakerWebp,
        name: 'Andrew N. Nunemaker',
        nameString: 'andrew-nunemaker',
        title: 'Chief Executive Officer Groupware Technologies',
        bioLink: '/assets/pdf/leaders/nunemaker.pdf',
      },
      {
        image: AnneParadisWebp,
        name: 'Anne M. Paradis',
        nameString: 'anne-paradis',
        title: 'Retired Chief Executive Officer MicroTek, Inc.',
        bioLink: '/assets/pdf/leaders/paradis.pdf',
      },
      {
        image: SandraRogersWebp,
        name: 'Sandra R. Rogers',
        nameString: 'sandra-rogers',
        title: 'Retired Vice President, Hillrom, Inc.',
        bioLink: '/assets/pdf/leaders/rogers.pdf',
      },
    ],
    [
      {
        image: AartiShahWebp,
        name: 'Aarti S. Shah',
        nameString: 'aarti-shah',
        title: (<>Retired Senior Vice President &#8211; Chief Information and Digital Officer, Eli Lilly and Company</>),
        bioLink: '/assets/pdf/leaders/shah.pdf',
      },
      {
        image: RalphWeberWebp,
        name: 'Ralph A. Weber',
        nameString: 'ralph-weber',
        title: 'General Counsel, Marquette University',
        bioLink: '/assets/pdf/leaders/weber.pdf',
      },
      {
        image: JuanZarateWebp,
        name: 'Juan C. Zarate',
        nameString: 'juan-zarate',
        title: (<>Global Co&#45;Managing Partner and Chief Strategy Officer K2 Integrity</>),
        bioLink: '/assets/pdf/leaders/zarate.pdf',
      },
    ],
  ],

};

const getPicture = (
  imageAlt,
  image,
) => {
  return (
    <Picture
      lazyLoad
      variant='rectangular'
      src={image}
      altText={imageAlt}
      fullWidth
    />
  );
};

export default () => {
  return(
    <SectionContainerStyled
      id='our-leaders-board-of-trustees'
      backgroundVariant='lightB'
      themeType='lightTheme'
      disableBottomPadding>
      <Row>
        <Col align='center'>
          <Typography
            component='h2'
            variant='h1'>
            Board of trustees
          </Typography>
        </Col>
      </Row>
      <DivStyledTrusteesGroupContainer>
        {(
          TRUSTEES.rows.map((item, index) => (
            <RowStyled
              key={`our-leaders-board-of-trustees-row-${index + 1}`}
              align='left'>
              {(item.map((person, i) => (
                <ColStyled
                  medium={4}
                  key={`our-leaders-board-of-trustees-${i + 1}`}>
                  <div
                    itemScope
                    itemType='https://schema.org/Person'>
                    <DivStyledPictureContainer itemProp='image'>
                      {getPicture(
                        person.name,
                        person.image,
                      )}
                    </DivStyledPictureContainer>
                    <TypographyStyled
                      itemProp='name'
                      component='h3'
                      variant='h2'>
                      {person.name}
                    </TypographyStyled>
                    <Typography
                      itemProp='jobTitle'
                      nextElement='button'>
                      {person.title}
                    </Typography>
                    <Link
                      id={`our-leader-board-of-trustees-${person.nameString}-bio-link`}
                      linkUrl={person.bioLink}
                      isOutgoingLink
                      endAdornment={CaratRight}
                      endAdornmentStylesReset
                      variant='buttonLinkTertiary'
                      ariaLabel={`Download the bio PDF for ${person.name}`}>
                      See full bio
                    </Link>
                  </div>
                </ColStyled>
              ),
              )
              )}
            </RowStyled>
          ),
          )
        )}
      </DivStyledTrusteesGroupContainer>
    </SectionContainerStyled>
  );
};
